import _Object$assign from "babel-runtime/core-js/object/assign";
import _regeneratorRuntime from "babel-runtime/regenerator";
import _Promise from "babel-runtime/core-js/promise";
import _asyncToGenerator from "babel-runtime/helpers/asyncToGenerator";
import _JSON$stringify from "babel-runtime/core-js/json/stringify";


import storage from "@/tools/storage";
import define from "@/config/defineConfig";
import sysConfig from "@/config/sysConfig";
import dict from "@/tools/dict";
import defineConfig from "@/config/defineConfig";
import org from "@/tools/org";
import date from "@/tools/date";
import { Store } from "vuex";
import bizBenefitMethod from "@/business/businessTools/bizBenefitMethod";

var transformObj = function transformObj(data, dictKeys) {
  var isArray = data && Array.isArray(data),
      cloneData = JSON.parse(_JSON$stringify(data)),
      newData = [];
  cloneData = isArray ? cloneData : [cloneData];
  cloneData.map(function (item) {
    var newItem = {};
    _.each(dictKeys, function (newKey, key) {
      !_.isUndefined(item[key]) && (newItem[newKey] = item[key]);
    });
    newData.push(newItem);
  });
  return isArray ? newData : newData[0];
};

export default {
  loadBusiData: function loadBusiData(oldBizData) {
    var _this = this;

    return _asyncToGenerator(_regeneratorRuntime.mark(function _callee2() {
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              return _context2.abrupt("return", dict.transformDict(oldBizData, "ID_TYPE").then(function (busiData) {
                var customerInfo = storage.$storage.getJsonSession(defineConfig.$definecfg.CUSTOMER_INFO);
                var newData = {
                  PRINT_DATE: date.formatDate(new Date(), "yyyy年MM月dd日")
                };
                var bizData = busiData.BIZ_DATA;
                return _Promise.all([customerInfo.INT_ORG ? org.getOrgDataById(customerInfo.INT_ORG, false, "0") : ""]).then(function () {
                  var _ref = _asyncToGenerator(_regeneratorRuntime.mark(function _callee(res) {
                    var custOrgFullName;
                    return _regeneratorRuntime.wrap(function _callee$(_context) {
                      while (1) {
                        switch (_context.prev = _context.next) {
                          case 0:
                            custOrgFullName = _.get(res[0], "ORG_FULL_NAME", "");

                            newData.CUST_ORG_FULL_NAME = bizData.CUST_ORG_FULL_NAME || custOrgFullName;

                            if (!(sysConfig.$syscfg.isOrgOpenAcctBiz(busiData.BUSI_CODE) || sysConfig.$syscfg.isProOpenAcctBiz(busiData.BUSI_CODE))) {
                              _context.next = 10;
                              break;
                            }

                            _context.next = 5;
                            return _this.loadOrgOpenBizData(newData, busiData);

                          case 5:
                            newData = _context.sent;

                            if (!sysConfig.$syscfg.isProOpenAcctBiz(busiData.BUSI_CODE)) {
                              _context.next = 10;
                              break;
                            }

                            _context.next = 9;
                            return _this.loadProOpenBizData(newData, busiData);

                          case 9:
                            newData = _context.sent;

                          case 10:
                            return _context.abrupt("return", newData);

                          case 11:
                          case "end":
                            return _context.stop();
                        }
                      }
                    }, _callee, _this);
                  }));

                  return function (_x) {
                    return _ref.apply(this, arguments);
                  };
                }());
              }));

            case 1:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, _this);
    }))();
  },
  loadOrgOpenBizData: function loadOrgOpenBizData(newData, busiData) {
    var _this2 = this;

    return _asyncToGenerator(_regeneratorRuntime.mark(function _callee3() {
      var bizData, imgData, custInfo, dictDatas, netInfo, openAcctType, trdacctInfoList, SZA, SHA, SHB, SZB, SHFUNDS, SZFUNDS, specialAcctNumSH, specialAcctNumSZ, i, listJSONObject, acctType, selType, openType, opType, legalInfo, dictDatas2, linkmanInfo, linkmanDicts, agentInfo, agentInfoDicts, benefitListObj;
      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              bizData = busiData.BIZ_DATA;
              imgData = busiData.IMG_DATA || {};
              custInfo = _Object$assign({}, bizData.BASE_INFO, bizData.KEY_INFO, bizData.CONTACT_INFO, bizData.EXT_INFO);

              newData.CUST_FNAME = custInfo.NEW_CUST_FNAME;
              newData.CUST_NAME = custInfo.NEW_CUST_NAME;
              newData.ID_CARD = custInfo.NEW_ID_CODE;
              newData.ID_CODE = custInfo.NEW_ID_CODE;
              newData.ID_TYPE = custInfo.NEW_ID_TYPE;

              newData.ORG_ENGLISH_NAME = custInfo.ORG_ENGLISH_NAME;

              newData.NEED_SYNC_CUST = custInfo.NEW_CUST_CODE;
              newData.NEW_CUST_CODE = bizData.NEW_CUST_CODE;
              newData.CUST_CODE = bizData.NEW_CUST_CODE || "";

              newData.SZORGTYPE = custInfo.SZORG_TYPE;
              newData.CITIZENSHIP = custInfo.CITIZENSHIP;

              custInfo.ID_TYPE = custInfo.NEW_ID_TYPE;

              custInfo.ZD_ID_TYPE = custInfo.ID_TYPE || "";
              _context3.next = 18;
              return dict.transformDict(custInfo, ["ID_TYPE", "SZORG_TYPE", "INDUS_GB", "CITIZENSHIP", "NATIONAL_ATTR", { ZD_ID_TYPE: "OPP_ZD_ID_TYPE_MAP_CONF" }, { REGISTER_CURRENCY: "CURR_NATL" }]);

            case 18:
              dictDatas = _context3.sent;

              newData.ID_TYPE_TEXT = dictDatas.ID_TYPE_TEXT || "";
              newData.SZORGTYPE_TEXT = dictDatas.SZORG_TYPE_TEXT || "";

              newData.INDUS_GB_TEXT = dictDatas.INDUS_GB_TEXT || "";
              newData.ZD_ID_TYPE_TEXT = dictDatas.ZD_ID_TYPE_TEXT || "";

              newData.CURRENCY_TEXT = dictDatas.REGISTER_CURRENCY_TEXT || "";
              newData.CITIZENSHIP_TEXT = dictDatas.CITIZENSHIP_TEXT || "";
              newData.NATIONAL_ATTR_TEXT = dictDatas.NATIONAL_ATTR_TEXT || "";
              newData.ID_EXP_DATE = custInfo.ID_EXP_DATE || "";
              newData.ID_EXP_DATE_PRINT = date.formatDate(custInfo.ID_EXP_DATE, "yyyy年MM月dd日");

              newData.BIRTHDAY = custInfo.BIRTHDAY || "";
              newData.BIRTHDAY_PRINT = date.formatDate(custInfo.BIRTHDAY, "yyyy年MM月dd日");
              newData.BUSINESS_RANGE = custInfo.BUSINESS_RANGE || "";

              newData.REGISTER_FUND = custInfo.REGISTER_FUND || "";

              newData.ORG_ID_CODE = custInfo.ORG_ID_CODE || "";

              newData.ORG_ID_EXP_DATE = custInfo.ORG_ID_EXP_DATE || "";
              newData.ORG_ID_EXP_DATE_PRINT = date.formatDate(custInfo.ORG_ID_EXP_DATE, "yyyy年MM月dd日");

              newData.CORP_QUAL_ID_NAME = custInfo.CORP_QUAL_ID_NAME || "";

              newData.CORP_QUAL_ID_CODE = custInfo.CORP_QUAL_ID_CODE || "";

              newData.CORP_QUAL_ID_EXP_DATE = custInfo.CORP_QUAL_ID_EXP_DATE || "";
              newData.CORP_QUAL_ID_EXP_DATE_PRINT = date.formatDate(custInfo.CORP_QUAL_ID_EXP_DATE, "yyyy年MM月dd日") || "";

              newData.CORP_QUAL_ID_ISS_AGCY_PRO = custInfo.CORP_QUAL_ID_ISS_AGCY_PRO || "";

              newData.CORP_QUAL_PERMIT = custInfo.CORP_QUAL_PERMIT || "";

              newData.ID_ADDR = custInfo.ID_ADDR || "";

              newData.ID_ADDR2 = custInfo.ID_ADDR2 || "";

              newData.CORP_ADDR = custInfo.CORP_ADDR || "";

              newData.ID_ZIP_CODE = custInfo.ID_ZIP_CODE || "";

              newData.SMFUND_MANAGER_ID = custInfo.SMFUND_MANAGER_ID || "";

              newData.NATIONAL_ATTR = custInfo.NATIONAL_ATTR || "";

              newData.CAPITAL_ATTR = custInfo.CAPITAL_ATTR || "";

              newData.CORP_ADDR = custInfo.CORP_ADDR || "";

              newData.RISK_FACTOR = custInfo.RISK_FACTOR || "";
              newData.RISK_FACTOR_FLAG = newData.RISK_FACTOR.includes("o") ? "1" : "0";

              netInfo = _.get(bizData, "NET_INFO") || {};

              newData.NET_SERVICE = netInfo.NET_SERVICE || "";
              newData.YMT_CODE = bizData.YMT_CODE || "";

              newData.IS_OPEN_FUNDS = imgData.IS_OPEN_FINANCIAL_FUTURES || "";
              newData.FINANCIAL_FUTURES_NUM = imgData.FINANCIAL_FUTURES_NUM || "";
              openAcctType = imgData.openAcctType || vm.$store.state.openAcctType;

              if (!newData.YMT_CODE && openAcctType === "1" && newData.NATIONAL_ATTR != "4") {
                newData.isShowNationaAttr = "1";
              } else {
                newData.isShowNationaAttr = "0";
              }
              newData.openAccType = openAcctType;
              if (newData.openAccType !== "2" && newData.YMT_CODE == "") {
                newData.NATIONAL_ATTR = "4";
              }
              trdacctInfoList = bizData.TRDACCT_INFO_LIST || [];
              SZA = "";
              SHA = "";
              SHB = "";
              SZB = "";
              SHFUNDS = "";
              SZFUNDS = "";
              specialAcctNumSH = 0;
              specialAcctNumSZ = 0;

              if (trdacctInfoList.length) {
                for (i = 0; i < trdacctInfoList.length; i++) {
                  listJSONObject = trdacctInfoList[i];
                  acctType = listJSONObject.ACCT_TYPE || "";
                  selType = listJSONObject.SEL_TYPE || "";
                  openType = listJSONObject.SEL_TYPE || "";
                  opType = listJSONObject.OP_TYPE || "";

                  if (acctType == "AG" && ["1", "2"].includes(selType)) {
                    specialAcctNumSH++;
                  }
                  if (["H8", "HO"].includes(acctType) && ["1", "2"].includes(selType)) {
                    specialAcctNumSZ++;
                  }

                  if (openType === "1" && opType === "$SZA") {
                    SZA = "1";
                  }

                  if (openType === "1" && opType === "$SHA") {
                    SHA = "1";
                  }

                  if (openType === "1" && opType === "$SHB") {
                    SHB = "1";
                  }

                  if (openType === "1" && opType === "$SZB") {
                    SZB = "1";
                  }

                  if (openType === "1" && opType === "$SHFUNDS") {
                    SHFUNDS = "1";
                  }

                  if (openType === "1" && opType === "$SZFUNDS") {
                    SZFUNDS = "1";
                  }
                }
              }
              newData.specialAcctNumSH = specialAcctNumSH || "0";
              newData.specialAcctNumSZ = specialAcctNumSZ || "0";
              newData.SZA = SZA || "";
              newData.SHA = SHA || "";
              newData.SHB = SHB || "";
              newData.SZB = SZB || "";
              newData.SHFUNDS = SHFUNDS || "";
              newData.SZFUNDS = SZFUNDS || "";

              newData.TRDACCT_INFO_LIST = trdacctInfoList;
              legalInfo = bizData.LEGAL_REP_INFO || {};

              newData.LEGAL_REP = legalInfo.LEGAL_REP || "";

              newData.LEGAL_REP_ID_TYPE = legalInfo.LEGAL_REP_ID_TYPE || "";
              legalInfo.LEGAL_REP_ZD_ID_TYPE = legalInfo.LEGAL_REP_ID_TYPE || "";
              _context3.next = 85;
              return dict.transformDict(legalInfo, [{ LEGAL_REP_ID_TYPE: "ID_TYPE" }, { LEGAL_REP_ZD_ID_TYPE: "OPP_ZD_ID_TYPE_MAP_CONF" }]);

            case 85:
              dictDatas2 = _context3.sent;

              newData.LEGAL_REP_ID_TYPE_TEXT = dictDatas2.LEGAL_REP_ID_TYPE_TEXT || "";

              newData.LEGAL_REP_ZD_ID_TYPE_TEXT = dictDatas2.LEGAL_REP_ZD_ID_TYPE_TEXT || "";

              newData.LEGAL_REP_ID_CODE = legalInfo.LEGAL_REP_ID_CODE || "";

              newData.LEGAL_REP_ID_EXP_DATE = legalInfo.LEGAL_REP_ID_EXP_DATE || "";
              newData.LEGAL_REP_ID_EXP_DATE_PRINT = date.formatDate(legalInfo.LEGAL_REP_ID_EXP_DATE, "yyyy年MM月dd日");

              newData.LEGAL_MOBILE_TEL = legalInfo.LEGAL_MOBILE_TEL || "";
              newData.LEGAL_PERSON_TEL = legalInfo.LEGAL_PERSON_TEL || "";

              newData.PARTNER_LIST = bizData.PARTNER_INFO_LIST;
              _context3.next = 96;
              return dict.transformDict(newData.PARTNER_LIST, [{ AREA: "CITIZENSHIP" }, { LIAB_TYPE: "DEBT_BEAR_WAY" }, { PID_TYPE: "ID_TYPE" }]);

            case 96:
              newData.PARTNER_LIST = _context3.sent;
              linkmanInfo = bizData.LINKMAN_INFO_LIST && bizData.LINKMAN_INFO_LIST[0] || {};

              newData.LEGAL_LINKMAN_MOBILE_TEL = linkmanInfo.LINKMAN_TEL || "";

              newData.LINKMAN_TEL = linkmanInfo.LINKMAN_TEL || "";

              newData.LINKMAN = linkmanInfo.LINKMAN || "";

              newData.LINKMAN_ID_TYPE = linkmanInfo.LINKMAN_ID_TYPE || "";
              _context3.next = 104;
              return dict.transformDict(linkmanInfo, [{ LINKMAN_ID_TYPE: "OPP_ZD_ID_TYPE_MAP_CONF" }]);

            case 104:
              linkmanDicts = _context3.sent;

              newData.LINKMAN_ZD_ID_TYPE_TEXT = linkmanDicts.LINKMAN_ID_TYPE_TEXT || "";

              newData.LINKMAN_ID = linkmanInfo.LINKMAN_ID || "";

              newData.LINKMAN_CORP_FAX = linkmanInfo.LINKMAN_CORP_FAX || "";

              newData.LINKMAN_MOBILE_TEL = linkmanInfo.LINKMAN_MOBILE_TEL || "";

              newData.LINKMAN_EMAIL = linkmanInfo.LINKMAN_EMAIL || "";

              newData.LINKMAN_CORP_URL = linkmanInfo.LINKMAN_CORP_URL || "";

              newData.MOBILE_TEL = linkmanInfo.LINKMAN_TEL || "";

              agentInfo = bizData.AGENT_INFO;

              newData.AGENT_USER_FNAME = agentInfo.USER_FNAME || "";

              newData.AGENT_SEX = agentInfo.SEX || "";

              newData.AGENT_ID_TYPE = agentInfo.ID_TYPE || "";
              agentInfo.AGENT_ZD_ID_TYPE = agentInfo.ID_TYPE || "";
              _context3.next = 119;
              return dict.transformDict(agentInfo, ["ID_TYPE", { AGENT_ZD_ID_TYPE: "OPP_ZD_ID_TYPE_MAP_CONF" }, "CORP_RELATION"]);

            case 119:
              agentInfoDicts = _context3.sent;

              newData.AGENT_ID_TYPE_TEXT = agentInfoDicts.ID_TYPE_TEXT;
              newData.AGENT_CORP_RELATION_TEXT = agentInfoDicts.CORP_RELATION_TEXT || "";

              newData.AGENT_ZD_ID_TYPE_TEXT = agentInfoDicts.AGENT_ZD_ID_TYPE_TEXT || "";

              newData.AGENT_ID_CODE = agentInfo.ID_CODE || "";

              newData.AGENT_EFFECT_DATE = agentInfo.ID_EXP_DATE || "";
              newData.AGENT_EFFECT_DATE_PRINT = date.formatDate(agentInfo.ID_EXP_DATE, "yyyy年MM月dd日");

              newData.AGENT_CORP_RELATION = agentInfo.CORP_RELATION || "";
              newData.AGENT_RELATION_PATION = agentInfo.RELATION_PATION || "";

              newData.AGENT_TEL = agentInfo.OFFICE_TEL || "";

              newData.AGENT_MOBILE_TEL = agentInfo.MOBILE_TEL || "";

              newData.AGENT_ID_ZIP_CODE = agentInfo.ID_ZIP_CODE || "";
              newData.AGENT_ZIP_CODE = agentInfo.ZIP_CODE || "";

              newData.AGENT_CORP_ADDR = agentInfo.CORP_ADDR || "";
              newData.AGENT_ADDRESS = agentInfo.ADDRESS || "";

              newData.AGENT_LINKADDR_ORDER = agentInfo.LINKADDR_ORDER;

              _context3.next = 137;
              return dict.transformDict(bizData.CONTROLLER_INFO_LIST, [{ CONTROLER_ID_TYPE: "ID_TYPE" }, { CONTROLER_ZD_ID_TYPE: "OPP_ZD_ID_TYPE_MAP_CONF" }]);

            case 137:
              bizData.CONTROLLER_INFO_LIST = _context3.sent;
              _context3.next = 140;
              return dict.transformDict(bizData.CONTROLLER_SOTCK_INFO_LIST, [{ CONTROLER_ID_TYPE: "ID_TYPE" }, { CONTROLER_ZD_ID_TYPE: "OPP_ZD_ID_TYPE_MAP_CONF" }]);

            case 140:
              bizData.CONTROLLER_SOTCK_INFO_LIST = _context3.sent;

              newData.CONTROL_LIST_0 = bizData.CONTROLLER_INFO_LIST;
              newData.CONTROL_LIST_1 = bizData.CONTROLLER_SOTCK_INFO_LIST;

              bizData.BENEFICIARY_INFO_LIST = _.forEach(bizData.BENEFICIARY_INFO_LIST, function (v) {
                v.BENEFICIARY_CITIZENSHIP = v.NATION || "";
              });
              _context3.next = 146;
              return dict.transformDict(bizData.BENEFICIARY_INFO_LIST, ["ID_TYPE", "SEX", "SPECIAL_PERSON_FLAG", "CREDIT_BENEFICIARY_TYPE", { BENEFICIARY_ID_TYPE: "ID_TYPE" }, { NATION: "CITIZENSHIP" }, { BENEFICIARY_CITIZENSHIP: "CITIZENSHIP" }, { IS_UPLOAD_IMG: "YES_NO" }, { ACT_CTRL_CPNY: "BOMIS_ACT_CTRL_CPNY" }]);

            case 146:
              bizData.BENEFICIARY_INFO_LIST = _context3.sent;

              newData.BENEFIT_LIST = bizData.BENEFICIARY_INFO_LIST;

              if (newData.BENEFIT_LIST.length) {
                if (bizBenefitMethod.isTrustProducts(bizData.PRODUCT_INFO && bizData.PRODUCT_INFO.PRO_CLS)) {
                  benefitListObj = bizBenefitMethod.getFilterBenefitListObj(newData.BENEFIT_LIST);

                  newData.CREDIT_BENEFIT_LIST = [];
                  _.each(bizBenefitMethod.BENEFICIARY_MODULES, function (moduleConfig) {
                    var key = moduleConfig.key,
                        title = moduleConfig.title,
                        item_title = moduleConfig.item_title,
                        type = moduleConfig.type;

                    newData.CREDIT_BENEFIT_LIST.push({
                      BENEFIT_LIST: benefitListObj[key],
                      ITEM_TITLE: item_title
                    });
                  });
                }
              }

              newData.CREDIT_LIST = bizData.CREDIT_INFO_LIST;

              newData.states = vm.$store.state.apptStatus;

              newData.PROPER_RISK_DATA = bizData.PROPER_DATA;
              newData.openAcctInfo = {
                OPENTMPL_CFG: bizData.OPENTMPL_CFG
              };

              newData.CUACCT_CODE = _.get(bizData, "CUACCT_INFO_LIST[0].NEW_ACCOUNT_CODE", "");
              newData.NEW_ACCOUNT_CODE = _.get(bizData, "CUACCT_INFO_LIST[0].NEW_ACCOUNT_CODE", "");
              return _context3.abrupt("return", newData);

            case 156:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, _this2);
    }))();
  },
  loadProOpenBizData: function loadProOpenBizData(newData, busiData) {
    var _this3 = this;

    return _asyncToGenerator(_regeneratorRuntime.mark(function _callee4() {
      var bizData, productInfo, keyInfo, proTrusteeInfo, proOrdInfo, investInfo, shareregInfo, CONTROLLER_ACTUAL_INFO_LIST, EXT_INFO, BASE_INFO, LINKMAN_INFO, IMG_DATA, MANAGER_INFO;
      return _regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              bizData = busiData.BIZ_DATA || {};
              productInfo = bizData.PRODUCT_INFO || {}, keyInfo = bizData.KEY_INFO || {}, proTrusteeInfo = bizData.PRO_TRUSTEE_INFO || {}, proOrdInfo = bizData.PRO_ORD_INFO || {}, investInfo = bizData.INVEST_INFO || {}, shareregInfo = bizData.SHAREREG_ORG_INFO || {}, CONTROLLER_ACTUAL_INFO_LIST = bizData.CONTROLLER_ACTUAL_INFO_LIST || [], EXT_INFO = bizData.EXT_INFO || {}, BASE_INFO = bizData.BASE_INFO || {}, LINKMAN_INFO = bizData.LINKMAN_INFO_LIST[0] || {}, IMG_DATA = busiData.IMG_DATA || {}, MANAGER_INFO = bizData.MANAGER_INFO || {};
              _context4.next = 4;
              return dict.transformDict(keyInfo, [{ NEW_ID_TYPE: "ID_TYPE" }]);

            case 4:
              keyInfo = _context4.sent;
              _context4.next = 7;
              return dict.transformDict(productInfo, [{ PRO_CLS: "PRDT_CLS" }, "PRO_BAK_ORG"]);

            case 7:
              productInfo = _context4.sent;

              newData.SMFUND_MANAGER_ID = BASE_INFO.SMFUND_MANAGER_ID || "";

              newData.PRO_NAME = productInfo.PRO_NAME || "";
              newData.PRO_SNAME = productInfo.PRO_SNAME || "";
              newData.PRO_FNAME = keyInfo.NEW_CUST_FNAME || "";
              newData.PRO_CREAT_DATE = productInfo.PRO_CREAT_DATE || "";
              newData.PRO_CREAT_DATE_PRINT = date.formatDate(productInfo.PRO_CREAT_DATE, "yyyy年MM月dd日");
              newData.PRO_ID_TYPE = keyInfo.NEW_ID_TYPE || "";
              newData.PRO_ID_CODE = keyInfo.NEW_ID_CODE || "";
              newData.PRO_CLS = productInfo.PRO_CLS || "";
              newData.PRO_SIZE = productInfo.PRO_SIZE || "";
              newData.PRO_BAK_ORG = productInfo.PRO_BAK_ORG || "";
              newData.PRO_BAK_ORG_TEXT = productInfo.PRO_BAK_ORG_TEXT || "";
              newData.PRO_BAK_CODE = productInfo.PRO_BAK_CODE || "";
              newData.PRO_BAK_DATE = productInfo.PRO_BAK_DATE || "";
              newData.PRO_BAK_DATE_PRINT = date.formatDate(productInfo.PRO_BAK_DATE, "yyyy年MM月dd日");
              newData.PRO_EXP_DATE = productInfo.PRO_EXP_DATE || "";
              newData.PRO_EXP_DATE_PRINT = date.formatDate(productInfo.PRO_EXP_DATE, "yyyy年MM月dd日");
              newData.INIT_LEVERAGE = productInfo.INIT_LEVERAGE || "";
              newData.STRUCT_PRO_FLAG = productInfo.STRUCT_PRO_FLAG || "";
              newData.INVEST_RANAGE = productInfo.INVEST_RANAGE || "";
              newData.PRO_OPEN_DATE = productInfo.PRO_OPEN_DATE || "";
              newData.PRDT_CLS = productInfo.PRO_CLS || "";
              newData.PRO_CLS_TEXT = productInfo.PRO_CLS_TEXT || "";
              newData.SMFUND_TYPE = productInfo.SMFUND_TYPE || "";
              newData.SMFUND_MANAGER_TYPE = productInfo.SMFUND_MANAGER_TYPE || "";
              newData.SMFUND_REMARK = productInfo.SMFUND_REMARK || "";
              newData.SMFUND_MANAGER_REMARK = productInfo.SMFUND_MANAGER_REMARK || "";
              newData.PRO_MANAGER_BAK_DATE_PRINT = date.formatDate(productInfo.PRO_MANAGER_BAK_DATE, "yyyy年MM月dd日");

              proOrdInfo.PRO_ORD_ZD_ID_TYPE = proOrdInfo.PRO_ORD_ID_TYPE || "";
              _context4.next = 39;
              return dict.transformDict(proOrdInfo, [{ PRO_ORD_ZD_ID_TYPE: "OPP_ZD_ID_TYPE_MAP_CONF" }, { PRO_ORD_ID_TYPE: "ID_TYPE" }, { AGENT_ZD_ID_TYPE: "OPP_ZD_ID_TYPE_MAP_CONF" }]);

            case 39:
              proOrdInfo = _context4.sent;
              _context4.next = 42;
              return dict.transformDict(proTrusteeInfo, [{ PRO_TRUSTEE_ID_TYPE: "ID_TYPE" }]);

            case 42:
              proTrusteeInfo = _context4.sent;

              newData.PRO_ORD = proOrdInfo || "";
              newData.PRO_TRUSTEE = proTrusteeInfo || "";

              _.each(CONTROLLER_ACTUAL_INFO_LIST, function (item) {
                return item.CONTROLER_ZD_ID_TYPE = item.CONTROLER_ID_TYPE;
              });
              _context4.next = 48;
              return dict.transformDict(CONTROLLER_ACTUAL_INFO_LIST, [{ CONTROLER_ID_TYPE: "ID_TYPE" }, { CONTROLER_ZD_ID_TYPE: "OPP_ZD_ID_TYPE_MAP_CONF" }]);

            case 48:
              CONTROLLER_ACTUAL_INFO_LIST = _context4.sent;
              _context4.next = 51;
              return dict.transformDict(EXT_INFO, ["INDUS_GB"]);

            case 51:
              EXT_INFO = _context4.sent;
              _context4.next = 54;
              return dict.transformDict(MANAGER_INFO, [{ PRO_MANAGER_ID_TYPE: "ID_TYPE" }]);

            case 54:
              MANAGER_INFO = _context4.sent;

              newData.CONTROL_LIST_2 = CONTROLLER_ACTUAL_INFO_LIST || [];
              newData.PRO_MANAGER_NAME = MANAGER_INFO.PRO_MANAGER_NAME || "";
              newData.INDUS_GB = EXT_INFO.INDUS_GB || "";
              newData.INDUS_GB_TEXT = EXT_INFO.INDUS_GB_TEXT || "";
              newData.ID_TYPE = MANAGER_INFO.PRO_MANAGER_ID_TYPE || "";
              newData.ID_TYPE_TEXT = MANAGER_INFO.PRO_MANAGER_ID_TYPE_TEXT || "";
              newData.ID_CODE = MANAGER_INFO.PRO_MANAGER_ID_CODE || "";
              newData.ID_EXP_DATE = MANAGER_INFO.PRO_MANAGER_ID_EXP_DATE || "";
              newData.ID_EXP_DATE_PRINT = date.formatDate(MANAGER_INFO.PRO_MANAGER_ID_EXP_DATE, "yyyy年MM月dd日");

              newData.SZORGTYPE = BASE_INFO.SZORG_TYPE, newData.PRO_MANAGER_BAK_DATE_PRINT = date.formatDate(productInfo.PRO_MANAGER_BAK_DATE, "yyyy年MM月dd日");

              investInfo.INVESTASER_ZD_ID_TYPE = investInfo.INVESTASER_ID_TYPE || "";
              investInfo.INVEST_REP_ZD_ID_TYPE = investInfo.INVEST_REP_ID_TYPE || "";
              _context4.next = 69;
              return dict.transformDict(investInfo, [{ INVESTASER_ID_TYPE: "ID_TYPE" }, { INVEST_REP_ID_TYPE: "ID_TYPE" }, { INVESTASER_ZD_ID_TYPE: "OPP_ZD_ID_TYPE_MAP_CONF" }, { INVEST_REP_ZD_ID_TYPE: "OPP_ZD_ID_TYPE_MAP_CONF" }]);

            case 69:
              investInfo = _context4.sent;

              investInfo.IS_INVEST_ADVISER = _.get(busiData, "DETAIL_DATA.INVEST_INFO.IS_INVEST_ADVISER");
              newData.INVESTASER = investInfo;
              shareregInfo.SHAREREG_ORG_ZD_ID_TYPE = shareregInfo.SHAREREG_ORG_ID_TYPE || "";
              _context4.next = 75;
              return dict.transformDict(shareregInfo, [{ SHAREREG_ORG_ID_TYPE: "ID_TYPE" }, { SHAREREG_ORG_ZD_ID_TYPE: "OPP_ZD_ID_TYPE_MAP_CONF" }]);

            case 75:
              shareregInfo = _context4.sent;

              newData.SHAREREG_ORG = shareregInfo;

              _context4.next = 79;
              return dict.transformDict(LINKMAN_INFO, [{ LINKMAN_ID_TYPE: "ID_TYPE" }]);

            case 79:
              LINKMAN_INFO = _context4.sent;

              newData.CONTRACT_INFO = LINKMAN_INFO;


              newData.CUST_RECHECK_RESULT_DETAIL = IMG_DATA.CUST_RECHECK_RESULT_DETAIL || "";
              newData.ALL_CUST_AGMT_TYPE_TEXT = IMG_DATA.ALL_CUST_AGMT_TYPE_TEXT || "";
              newData.ZY_CUST_AGMT_TYPE_TEXT = IMG_DATA.ZY_CUST_AGMT_TYPE_TEXT || "";
              newData.STKBD_TRDACCT = IMG_DATA.STKBD_TRDACCT || "";
              newData.IS_OPEN_FUNDS = _.get(bizData, "OPEN_FUND_INFO.IS_OPEN_FINANCIAL_FUTURES", "");
              newData.FINANCIAL_FUTURES_NUM = _.get(bizData, "OPEN_FUND_INFO.FINANCIAL_FUTURES_NUM", "");
              newData.OA_NUM = _.get(bizData, "OPEN_FUND_INFO.OA_NUM", "");
              return _context4.abrupt("return", newData);

            case 89:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, _this3);
    }))();
  }
};


//////////////////
// WEBPACK FOOTER
// ./src/assets/busi-paper/prints/GUOTOU/imgClsCommon.js
// module id = 1131
// module chunks = 2